import { useNavigate } from "react-router-dom";

import TemplateStep2 from "Components/Templates/Step2";

const data = {
   v_name: "",
   email: "",
   hp: "",
   name: "", // 전시회 이름
   museum: 0, // 전시관 id
   startdate: "",
   enddate: "",
   runtime: "",
   author: "", //@9596,@649
   authorplus: "", // ,로 구분한 작가들 이름
   file2: "",
};

export default function PageStep2() {
   console.log("step 2");
   const navigate = useNavigate();

   function nextOnClick() {
      navigate("/steps/3");
   }

   return (
      <>
         <TemplateStep2 nextOnClick={nextOnClick} data={data}></TemplateStep2>
      </>
   );
}
